import { RankingComponent } from './ranking/ranking.component'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { RankingResolver } from './ranking/ranking.resolver'
import { MetaGuard } from 'meta'
import { RedirectGuard } from '../libs/common/redirect.guard'
import { RankingsComponent } from './rankings/rankings.component'
import { RankingsGuard } from '../shared/guards/rankings.guard'
import { RANKINGS_LIST } from './rankings-analytics.service'
import { SegmentTagMap } from '../shared/analytics/models/segment-tag-map.model'
import { pathMatcher } from '../shared/utility-functions/slug.utility'
import { CORE_ID_RULES } from '../shared/utility-functions/regex.utility'

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: RankingsComponent,
        canActivate: [MetaGuard, RankingsGuard],
        data: {
          /**
           * This will both prevent automatic page calls and also allow the
           * analytics directive to work.
           *
           * @see outExcludedRoutes
           */
          segment: RANKINGS_LIST,
          shouldShowEventTicker: true,
          meta: {
            'og:type': 'meta_ranking_page_type'
          },
          noTopScroll: true
        },
        children: [
          {
            path: 'search',
            component: RankingsComponent
          }
        ]
      },
      {
        path: ':slug',
        resolve: { node: RankingResolver },
        canActivate: [MetaGuard, RedirectGuard],
        data: {
          redirect: {
            testRegExp: /\/rankings\/6811625/,
            newUrl: 'https://leaderboard.varsity.com'
          },
          segment: SegmentTagMap.RANKINGS_DETAIL,
          shouldShowAdSkin: false,
          shouldShowEventTicker: true,
          meta: {
            'og:type': 'meta_ranking_page_type'
          }
        },
        children: [
          {
            matcher: url => pathMatcher(url, 'rankingSlug', CORE_ID_RULES),
            component: RankingComponent,
            data: {
              noTopScroll: true
            }
          }
        ]
      }
    ])
  ],
  exports: [RouterModule],
  providers: [RankingsGuard]
})
export class RankingsRoutingModule {}
